import { Component, Input } from '@angular/core';
import { ConsoleSettingTab } from '@models/console-settings';
import { Vessel } from 'icreate/common/models/vessel';

@Component({
    selector: 'app-console-settings',
    templateUrl: './console-settings.component.html',
    styleUrl: './console-settings.component.css',
    standalone: false,
})
export class ConsoleSettingsComponent {
    readonly TABS = Object.values(ConsoleSettingTab);
    readonly ALARM_GROUPS = ConsoleSettingTab.ALARM_GROUPS;

    @Input() vessel: Vessel;
    @Input() userCanEdit: boolean;
    selectedSetting: ConsoleSettingTab;

    constructor() {}

    selectTab(tab: ConsoleSettingTab) {
        this.selectedSetting = tab;
    }
}
